document.querySelectorAll('[data-product-purchase]').forEach(purchase => {
  const form = purchase.querySelector('[data-product-form]');
  if (!form) return;
  const select = form.querySelector('select[name="id"]');
  if (!select) return;
  const price = purchase.querySelector('[data-price]');
  const compare = purchase.querySelector('[data-compare-price]');
  const button = form.querySelector('[type="submit"]');
  const initial = { price: price.textContent, compare: compare.querySelector('s').textContent, hidden: compare.hidden };
  const update = () => {
    const option = select.selectedOptions[0];
    const selected = Boolean(select.value && option);
    price.textContent = selected ? option.dataset.price : initial.price;
    compare.querySelector('s').textContent = selected ? option.dataset.comparePrice || '' : initial.compare;
    compare.hidden = selected ? !option.dataset.comparePrice : initial.hidden;
    button.disabled = !selected || option.disabled;
  };
  select.addEventListener('change', update);
  update();
  form.addEventListener('submit', () => {
    if (form.checkValidity()) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }
  });
});
window.addEventListener('pageshow', () => document.querySelectorAll('[data-product-form] select').forEach(select => select.dispatchEvent(new Event('change'))));
